import * as angular from 'angular';

import { ComponentDefinition } from '../../models';

class FileChooserController implements angular.IComponentController {
    formController: angular.IFormController;
    ignoreForm: boolean;

    static $inject = [];

    setFormState() {
        if (this.ignoreForm) {
            this.formController.$setPristine();
        }
    }
}

export const wtFileChooser: ComponentDefinition = {
    componentId: 'wtFileChooser',
    controller: FileChooserController,
    template: require('./fileChooser.component.html'),
    controllerAs: 'vm',
    bindings: {
        fileList: '=',
        controlId: '@',
        types: '@',
        ignoreForm: '@?',
        formController: '=?'
    }
};